import React from 'react';
import './style.css'
import { Container, Jumbotron } from 'react-bootstrap';
import { Player } from 'video-react';
import Row from 'react-bootstrap/Row'


<link
    rel="stylesheet"
    href="https://video-react.github.io/assets/video-react.css"
/>

function DeleteAccountInfo() {
    return (
        <div>
            <Container fluid='md'>
                <Jumbotron>
                    <h1>Solicitud de eliminación de cuenta</h1>
                </Jumbotron>

                <p>
                    Al eliminar tu cuenta todos tus datos serán borrados de nuestro servidor (incluyendo comentarios, favoritos y nombre e imagen de usuario) y tendrás que volver a registrarte para utilizar las funciones que requieran una sesión activa, <strong>esta acción no se puede deshacer</strong> y será ejecutada en un plazo de 3 días hábiles.
                </p>

                <p>Para enviar una solicitud necesitas tener la versión 5.0.2 o posterior de la aplicación y una sesión activa, posteriormente dirígete al menú del toolbar y selecciona la opción <strong>“Solicitar eliminación de cuenta”</strong>, por último, selecciona la opción <strong>“Eliminar”</strong>. </p>

                <Row className='justify-content-center'>
                    <div style={{ backgroundColor: "blue", width: "50%", alignContent: 'center' }}>
                        <Player>
                            <source src="/deleteAccountVideo.mp4" />
                        </Player>
                    </div>
                </Row>

                <div style={{ backgroundColor: "red" }}>

                </div>

            </Container>


        </div>
    )
}

export default DeleteAccountInfo;